import {
  centerNameBreak,
  DesktopContent,
  Toolbar,
} from '__pages/Common/styles/ControlBar';
import BackButton from '__components/Button/BackButton';
import React, { ReactNode } from 'react';
import {
  StyledToolbarLeft,
  StyledToolbarWrapper,
} from '__pages/ActivitySettings/pages/ScheduledAndLogged/styled';

interface StyledBackBreadcrumbToolbarProps {
  goBackPath: string;
  backLabel?: string;
  children?: ReactNode;
}

export const StyledBackBreadcrumbToolbar: React.FC<
  StyledBackBreadcrumbToolbarProps
> = ({ goBackPath, backLabel = 'back to forms', children, ...rest }) => {
  return (
    <StyledToolbarWrapper className="toolbar-wrapper" {...rest}>
      <Toolbar className="toolbar">
        <StyledToolbarLeft nameBreakpoint={centerNameBreak}>
          <BackButton to={goBackPath} style={{ marginRight: 0 }}>
            <DesktopContent>{backLabel}</DesktopContent>
          </BackButton>
        </StyledToolbarLeft>
        {children}
      </Toolbar>
    </StyledToolbarWrapper>
  );
};
